import React, { Component } from "react";
import commonUtil from "../../../../../../../utils/commonUtil";
import * as giftListActions from "../../../actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const { getMessagesService, getAllMessagesService, addThankYouMessage, getRegisteredGiftList } =
  giftListActions;

class ChatMessageWap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "",
      hideButton: false,
      repliedMessage: "",
    };
  }
  selectedProduct = this.props.selectedProduct;

  componentDidMount() {
    commonUtil.goToTop();
    this.setState({ message: "", repliedMessage: "",  hideButton: false });
  }

  UNSAFE_componentWillMount() {
    this.props.getMessagesService(
      this.props.eventId,
      this.selectedProduct.purchaseItemId
    );
  }

  sendThankyouMessage = (purchaseItemId, newMessage) => {
    const message = newMessage;

    const receivedGiftList =
      this.props.receivedGiftList && this.props.receivedGiftList.categoryList
        ? this.props.receivedGiftList
        : [];

    const currentPage = receivedGiftList?.currentPage || 1;

    addThankYouMessage(this.props.eventId, purchaseItemId, message, "").then(
      (response) => {
        if (response?.body?.status?.status === "success") {
          this.props.getRecievedGiftList(
            "",
            this.props.sortingValue || "Ascending",
            this.props.filterParams || [],
            currentPage || 1
          );

          this.selectedProduct.messageInfo = "replied";
          this.props.getAllMessagesService(
            this.props.eventId,
          );
        }
      }
    );
  };

  handleChange = (e) => {
    const value = e.target.value;
    this.setState({ message: value }, () => {
      if (this.textarea) {
        this.textarea.style.height = "auto";
        this.textarea.style.height = this.textarea.scrollHeight + "px";
      }
    });
  };

  handleSend = () => {
    const { message } = this.state;
    const purchaseItemId = this.selectedProduct.purchaseItemId;

    if (message.trim()) {
      const userMessage = message;
      this.sendThankyouMessage(purchaseItemId, userMessage);
      this.setState({
        repliedMessage: userMessage,
        message: "",
        hideButton: true,
      });
    }
  };

  messageLengthValidation = (e) => {
    if (e.target.value.length >= 300 && e.keyCode !== 8) {
      e.target.value = e.target.value.slice(0, 300);
    }
  };

  render() {
    const { message, hideButton, repliedMessage } = this.state;
    const { messages, lables } = this.props;

    return (
      <div id="chat-message-modal">
        {/* Message content */}
        {
          messages.customMessage && (
<div className="chat-body-wap">
          <div className="message-bubble">
            <div className="message-text">
              {messages.customMessage}
            </div>
          </div>

          {hideButton && repliedMessage && (
            <div className="message-bubble right">
              <div className="message-text">{repliedMessage}</div>
            </div>
          )}
        </div>
          )
        }
        

        {hideButton && repliedMessage ? (
          // <div
          //   id="#event-gift-modal-overlay"
          //   className={`col-xs-12 col-sm-12 chat-wap-back`}
          // >
          //   <button
          //     className={`btnPrimary size-Full chat-wap-back-btn`}
          //     aria-hidden="false"
          //     onClick={this.props.handleChatBackModalOverlay}
          //   >
          //     {commonUtil.getLabel(
          //       lables.EventAdminPage,
          //       "adminpage.regalosrecibidos.cerrar.label"
          //     )}
          //   </button>
          // </div>
          <div></div>
        ) : (
          <div className="chat-input-wrapper-wap">
            <div className="chat-input-box">
              <textarea
                ref={(el) => (this.textarea = el)}
                className="chat-input-field"
                placeholder="Escribe un mensaje"
                value={message}
                onChange={this.handleChange}
                rows={1}
                onKeyUp={(e) => this.messageLengthValidation(e)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    this.handleSend();
                  }
                }}
                maxLength={300}
              />
              <div className="chat-send-wrapper">
                <button className="chat-send-btn" onClick={this.handleSend}>
                  <img
                    src={commonUtil.getAssetURL() + "/images/send.svg"}
                    alt="Send"
                    className="chat-pointer"
                  />
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  messages: state.giftList.data.messageInfo,
  messageLoaded: state.giftList.messageLoaded,
});
const matchDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getMessagesService,
      getAllMessagesService,
      getRegisteredGiftList,
    },
    dispatch
  );

export default connect(mapStateToProps, matchDispatchToProps)(ChatMessageWap);
